import OrderItemController from './orderItemController';
import OrdersService from '@services/OrdersService';
import assign from 'object-assign';
import {Corpus} from '@modules/lazy-imports';

export default OrderItemController.extend( {
    defaults: {
        request: OrdersService.getOrderDetailsAndTracking
    },

    events: {
        // Caveat - current implementation does not inherit event object. Events from parent must be inherited manually
        // parent
        'click .print-invoice': 'handlePrintInvoice',
        'contenteditable:saved': 'handlePONumber',
        'click .button-bar': 'setActiveTab'
    },

    elements: {
        '.accordion-content': 'contentArea',
        '.odr-po': 'pofieldWrapper',
        '.odr-po input': 'pofield'
    },

    init: function ( el, options ) {
        this.options = this.options || {};
        assign( this.options, this.defaults, options || {} );

        this._super( el, options );
    },

    renderOrderPartial: function ( $invoice ) {
        // extract the invoice and order actions from page markup
        var invoiceHTML = $( '<div class="slideDown"/>' ).html( $invoice.find( '.odr-details + div' ) );
        this.contentArea.html( invoiceHTML.html() );

        Corpus().then( () => {
            this.el.corpus( 'tabs', {
                scopeIsTarget: true,
                controls: '.tabNavigation',
                panel: '.tabPanel',
                active_class: 'current'
            } );

            this.el.data( 'content-loaded', true );
            this.update_elements();
        } );
    },

    setActiveTab: function ( e ) {
        // ensure the accordion is open
        this.el.trigger( {type: 'open:accordion', item: this.el} );

        // set .current class on clicked tab button so when the tab module is initialized
        // this is the tab in view
        $( e.currentTarget ).find( 'li' ).removeClass( 'current' );
        $( e.target ).addClass( 'current' );
    }

} );
